import React, { useState } from 'react';
import { TextField, Button, Box, CircularProgress, Snackbar, Alert } from '@mui/material';

const NETLIFY_ENDPOINT = 'https://gentle-tanuki-6cbd7a.netlify.app/';

function NewsletterSubscription() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const [ok, setOk] = useState(false);

  const encode = (data) =>
    Object.keys(data)
      .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    setOk(false);

    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!isValid) {
      setErr('Please enter a valid email');
      return;
    }

    setLoading(true);
    try {
      // IMPORTANT: form-name must match the Netlify form's "name"
      const body = encode({ 'form-name': 'newsletter', email });

      await fetch(NETLIFY_ENDPOINT, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
      });

      setOk(true);
      setEmail('');
    } catch (e) {
      setErr('Submission failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        mt: { xs: 2.5, sm: 3, lg: 4 },
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 1, sm: 1.5 },
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'all 0.5s ease-out',
      }}
    >
      <TextField
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        type="email"
        fullWidth
        sx={{
          backgroundColor: 'white',
          borderRadius: 2,
          '& fieldset': { borderRadius: 2 },
          width: { xs: '100%', sm: '14rem', md: '15rem', lg: '16rem' },
          transition: 'all 0.5s ease-out',
          '&:focus-within': {
            width: { xs: '18rem', sm: '20rem', md: '22rem', lg: '30rem' },
          },
          '& .MuiInputBase-root': {
            fontFamily: 'Poppins',
            height: { xs: '44px', sm: '52px' },
          },
        }}
        error={Boolean(err)}
        helperText={err ? err : ''}
        placeholder="Enter your email waitlist"
      />

      <Button
        type="submit"
        variant="contained"
        disabled={loading}
        sx={{
          backgroundColor: '#ff0050',
          color: '#fff',
          padding: '10px 25px',
          borderRadius: '10px',
          fontSize: '18px',
          height: '45px',
          width: { xs: '90vw', sm: 'auto' },
          '&:hover': { backgroundColor: '#e60047' },
        }}
        startIcon={loading ? <CircularProgress size={18} /> : null}
      >
        {loading ? 'Submitting...' : 'Submit'}
      </Button>

      {/* success toast */}
      <Snackbar open={ok} autoHideDuration={3000} onClose={() => setOk(false)}>
        <Alert severity="success" variant="filled" onClose={() => setOk(false)}>
          Subscription successful!
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default NewsletterSubscription;
